import { render, staticRenderFns } from "./RadioBoxList.vue?vue&type=template&id=67afa3c4&"
import script from "./RadioBoxList.vue?vue&type=script&lang=js&"
export * from "./RadioBoxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports